export const REPORTS_READ = "reports.read";
export const REPORTS_BUILD = "reports.build";
export const REPORTS_SHARE = "reports.share";
